import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const LOGIN_REQUEST = "auth/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGOUT_REQUEST = "auth/LOGOUT_REQUEST";

export const authActionCreators = {
  login: createPromiseAction(LOGIN_REQUEST),
  loginSuccess: createAction(LOGIN_SUCCESS),
  logout: createAction(LOGOUT_REQUEST),
};
